import { FC } from 'react';

const PanelTitle: FC<{ modalName: string }> = ({ modalName }) => {
  return (
    <div className="fs-18 lh-120 h-inherit bg-Primary-Primary-200 tw:capitalize flex flex-auto items-center justify-center">
      {modalName}
    </div>
  );
};

export default PanelTitle;
